import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { resetUpdateUserAccount, updateUserAccount } from "./update-user-account";

const initialState: ProcessingState = { processing: "idle" };

export const updateUserAccountReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(updateUserAccount.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(updateUserAccount.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateUserAccount.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateUserAccount, () => {
    return initialState;
  });
});
